module.exports = __webpack_public_path__ + "static/media/maca.0106bde4.png";